
import {Vue, Component, Prop} from "vue-property-decorator";
import {TranslateResult} from "vue-i18n";

@Component({})
export default class SimpleDialog extends Vue {
    @Prop({default: false})
    public dialog: boolean;

    @Prop({default: null})
    public title: string|TranslateResult;

    @Prop({default: null})
    public text: string|TranslateResult;

    @Prop({default: []})
    public actions: string[];

    @Prop({default: false})
    public disabled: boolean;

    @Prop({default: false})
    public loading?: boolean;

    @Prop({default: false})
    public mobile?: boolean;

    @Prop({default: true})
    public persistent?: boolean;

    @Prop({default: 500})
    public width?: number;

    @Prop({default: null})
    public color?: string;

    private clickOutside() {
        if (!this.persistent) {
            this.$emit("close");
        }
    }
}
